module.exports = __webpack_public_path__ + "static/img/checkbox-rounded-unchecked@2x.b747b39.png";